import { render, staticRenderFns } from "./createMerchant.vue?vue&type=template&id=9aca45e2&scoped=true&"
import script from "./createMerchant.vue?vue&type=script&lang=js&"
export * from "./createMerchant.vue?vue&type=script&lang=js&"
import style0 from "./createMerchant.vue?vue&type=style&index=0&id=9aca45e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aca45e2",
  null
  
)

export default component.exports